(ns dre.components.user-menu.notifications.views
  (:require
   [clojure.string :as str]
   [dre.app.router :as router :refer [->route]]
   [dre.components.dropdown :refer [dropdown]]
   [dre.components.icon :refer [svg fa-icon]]
   [dre.components.list :refer [collapsable-list]]
   [dre.components.tabs :refer [tabs]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.components.user-menu.notifications.events :as events]
   [dre.i18n.utils :refer [tr-later]]
   [dre.page-util :refer [nbsp dangerous md]]
   [dre.pages.my-searches.signals.events :as signal-events]
   [dre.util :refer [in?]]
   [dre.utils.bem :as bem]
   [dre.utils.query :as q]
   [markdown.core :as md]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :notifications)

(defn bubble
  [count]
  [:span.unread
   {:data-unread-count count} count])

(defn tab-items
  [unread-count]
  [{:id :signals
    :label [:span
            (tr-later "Saved Searches")
            [bubble (unread-count "signals")]]}
   {:id :shared-query
    :label [:span
            (tr-later "Shared")
            [bubble (unread-count "shared-query")]]}
   {:id :release-notes
    :label [:span
            (tr-later "Broadcasts")
            [bubble (unread-count "release-notes")]]}])

(defn signals-list
  [notifications]
  [collapsable-list
   (remove nil? (mapv (fn [n]
                        (let [{:keys [:object-id :read :notification-uuid]} n
                              signal @(rf/subscribe [::signal-events/uuid->simple-signal object-id])
                              navigate! #(let [search-query (:query/search-query signal)]
                                           (rf/dispatch [::events/mark-read notification-uuid])
                                           (rf/dispatch [::router/redirect-to-path-with-query-params
                                                         (->route :search)
                                                         ;;TODO add user hash
                                                         (:query-params (q/route search-query nil))]))
                              title (:signal/title signal)
                              new-articles (:signal/new-articles signal)]
                          (when title
                            {:actions [(when (not= new-articles 0)
                                         (r/as-element [:span
                                                        {:class (bem/be component-name :new-items)}
                                                        new-articles]))
                                       (if (:read n) nbsp (r/as-element [tooltip-wrapper "Unread" [fa-icon :circle {:class (bem/be component-name :unread)}]]))]
                             :content (r/as-element [:a.clickable
                                                     {:on-click navigate!
                                                      :class (bem/be component-name :notification-list-item)}
                                                     title])}))) notifications))
   -1])

(defn shared-query-list
  [notifications]
  [collapsable-list
   (mapv (fn [n]
           (let [{:keys [:description :type :object-id :notification-uuid]} n
                 parsed-object-id (str/split object-id "&")
                 query-params (if (= 1 (count parsed-object-id))
                                {:query object-id}
                                {:query (last parsed-object-id) :order (first parsed-object-id)})
                 navigate!
                 #(do
                    (rf/dispatch [::events/mark-read notification-uuid])
                    (rf/dispatch [::router/redirect-to-path-with-query-params (->route :search) query-params]))]
             {:actions [(r/as-element [md type])
                        (if (:read n) nbsp (r/as-element [tooltip-wrapper "Unread" [fa-icon :circle {:class (bem/be component-name :unread)}]]))]
              :content (r/as-element [:a.clickable
                                      {:on-click navigate!
                                       :class (bem/be component-name :notification-list-item)}
                                      description])})) notifications)
   -1])

(defn release-notes-list
  [notifications]
  [collapsable-list
   (mapv (fn [n]
           (let [{:keys [:description :read :notification-uuid]} n]
             {:actions [(if read nbsp (r/as-element [tooltip-wrapper "Unread" [fa-icon :circle {:class (bem/be component-name :unread)}]]))]
              :content (r/as-element [:span
                                      {:on-click #(rf/dispatch [::events/mark-read notification-uuid])}
                                      (dangerous :span (md/md->html description))])})) notifications)
   -1])

(defn notifications-list
  [_source _notifications]
  (r/create-class
   {:reagent-render
    (fn [source notifications]
      [:div
       {:class (bem/be component-name :notifications-list)}
       (if-not (seq notifications)
         [:div
          (str "🎉 " (tr-later "Nothing here!"))]
         (case source
           "signals"
           [signals-list notifications]
           "shared-query"
           [shared-query-list notifications]
           "release-notes"
           [release-notes-list notifications]))])}))

(defn content
  [notifications notification-filter]
  (let [notifications (if (fn? notification-filter)
                        (filter notification-filter notifications)
                        notifications)
        grouped (group-by :source notifications)
        unread-count #(count (remove :read (get grouped %)))
        active-tab @(rf/subscribe [::events/active-tab (tab-items unread-count)])
        active-name (name (:id active-tab))]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :header)}
      (tr-later "Notifications")
      [:span
       {:class [(bem/be component-name :mark-read)]
        :on-click #(rf/dispatch [::events/mark-read (->> active-name
                                                         (get grouped)
                                                         (map :notification-uuid))])}
       "Mark all as read"]]
     [tabs {:items (tab-items unread-count)
            :on-click (fn [e] (rf/dispatch [::events/set-active-tab e]))
            :default-active-id (:id active-tab)}]
     [notifications-list active-name (get grouped active-name)]
     ]))

(defn broadcast-button
  [has-updates? num-updates]
  [tooltip-wrapper (if has-updates? (str num-updates " new notifications") "Notifications")
   [:button
    {:class [(bem/bm :button :bare) (bem/be component-name :bell)]}
    [svg :common :bell]
    (when has-updates?
      [:span.unread-bubble])]])


(defn broadcast-dropdown
  [_menu-component-name]
  (rf/dispatch [::events/fetch])
  (let [module nil
        notification-filter (fn [{:keys [:modules]}]
                              (if (= module :regintel)
                                (in? modules "regintel")
                                (not (in? modules "regintel"))))]
    (r/create-class
     {:reagent-render
      (fn [menu-component-name]
        (let [notifications @(rf/subscribe [::events/notifications])
              unread @(rf/subscribe [::events/unread])
              num-updates (count (filter notification-filter unread))
              has-updates? (pos? num-updates)]
          [:div
           {:class (bem/be menu-component-name :broadcast-dropdown)}
           [dropdown
            {:alignment :right

             :anchor
             [broadcast-button has-updates? num-updates]

             :content
             [content notifications notification-filter]}]]))})))
